import { ReactNode } from "react"
import "./table.css"

type Props = {
  columns: { id: string; title: string }[]
  rows: ({ id: string | number } & Record<any, ReactNode>)[]
  onRowClick?: (id: number | string) => void
}
export const Table = ({ columns, rows, onRowClick }: Props) => {
  return (
    <table className="main">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.id}>{col.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => {
          const isDeleted = Boolean(
            row.deletedAt && new Date(row.deletedAt as string).getTime() > 0,
          )
          let rowClassname = isDeleted ? "deleted-tr" : ""
          if (row.error) {
            rowClassname = isDeleted ? "error-deleted-tr" : "error-tr"
          }
          return (
            <tr
              key={i}
              onClick={() => onRowClick?.(row.id)}
              className={rowClassname}
            >
              {columns.map((col) => (
                <td key={`${col.id}-${i}`}>{row[col.id]}</td>
              ))}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
